import type { FC } from 'react'
import { Resource } from '@chegg-wt/core/types/core'
import { ResourcesSection } from '@chegg-wt/core-wa/components/ResourceSection'
import CardImageCarousel from '@chegg-wt/core-wa/components/CardImageCarousel'
import WAHomepageHeadings from '@chegg-wt/core-wa/components/WAHomepageHeadings'
import InfoBanner from '@chegg-wt/core-wa/components/HomeInfoBanner'
import { WritingAssistantHomeBody } from './styled'

interface WritingAssistantHomeProps {
  copy: {
    resources: Resource[]
  }
}

const WritingAssistantHome: FC<WritingAssistantHomeProps> = ({ copy }) => {
  return (
    <div>
      <WritingAssistantHomeBody>
        <WAHomepageHeadings />
        <CardImageCarousel />
        <InfoBanner />
        <ResourcesSection resources={copy.resources} />
      </WritingAssistantHomeBody>
    </div>
  )
}
export default WritingAssistantHome
